import moment from 'moment';
import { getResourceTo } from './utils';

export const getOneFaceProviderResources = () => {
  const onefaceResources = {
    table: {
      loading: getResourceTo('loading.message'),
      results: getResourceTo('oneface.table.results'),
      deleteRegisters: getResourceTo('oneface.table.deleteRegisters'),
      newRegister: getResourceTo('oneface.table.newRegister'),
      selected: 'Selected',
      configureLayout: {
        title: getResourceTo('oneface.table.configureLayout.title'),
        dropAttributesMessage: getResourceTo(
          'oneface.table.configureLayout.dropAttributesMessage'
        ),
        buttonSave: getResourceTo('oneface.table.configureLayout.buttonSave'),
        buttonClose: getResourceTo('oneface.table.configureLayout.buttonClose')
      }
    },
    filterBuilder: {
      clearButton: getResourceTo('RouteMonitor.Btn.ClearFilters'),
      submitButton: getResourceTo('textfile.history.search'),
      popupSelect: {
        noOptionsMessage: getResourceTo('RepetitionField.noOptions'),
        placeholder: getResourceTo('RepetitionField.select')
      },
      intervalText: getResourceTo('general.range')
    },
    datepicker: {
      btnClear: getResourceTo('default.button.clear'),
      btnToday: getResourceTo('today')
    },
    lookupField: {
      btnCancel: getResourceTo('ConfirmModal.CancelButton'),
      btnSelect: getResourceTo('RepetitionField.select')
    },
    time: {
      title: getResourceTo('DateTimePicker.pickATime'),
      days: getResourceTo('DateTimePicker.days'),
      hours: getResourceTo('DateTimePicker.hours'),
      minutes: getResourceTo('DateTimePicker.Minute'),
      seconds: getResourceTo('DateTimePicker.seconds'),
      period: getResourceTo('DateTimePicker.ampm'),
      confirm: getResourceTo('DateTimePicker.Done'),
      now: getResourceTo('DateTimePicker.Now')
    }
  };

  return onefaceResources;
};

export const getTimeInputFormat = (gmsTimeFormat) => {
  const mappedTimeFormats = {
    'hh:mm a': 'hh:mm aa',
    'HH:mm': 'HH:mm'
  };

  return mappedTimeFormats?.[gmsTimeFormat] ?? 'hh:mm aa';
};

export const getLocation = (gmsLocation) => {
  const mappedLocations = {
    'es-PA': 'es',
    pl: 'pl',
    'es-CO': 'es',
    ja: 'ja',
    th: 'th',
    en: 'enUS',
    pt: 'ptBR',
    es: 'es',
    he: 'he',
    fr: 'fr',
    de: 'de',
    it: 'it',
    'es-CL': 'es',
    ru: 'ru',
    ar: 'ar',
    'es-NI': 'es',
    'es-CR': 'es',
    'es-GT': 'es'
  };

  return mappedLocations?.[gmsLocation] ?? 'enUS';
};

export const getDateFormatted = () => {
  const format = Monet.I18n.locale.dateFormat.toLowerCase();
  return format.replace('mm', 'MM');
};

export const convertHourToSeconds = (fullTime) => {
  if (!fullTime) return 0;
  let h = 0;
  let m = 0;
  let s = 0;

  const [time, period] = fullTime.split(' ');
  const [hours, minutes, seconds] = time.split(':');

  if (hours && hours !== '12' && period && period === 'PM') {
    h = (parseInt(hours, 10) + 12) * 3600;
  }

  if (hours && hours === '12' && period && period === 'AM') {
    h = 0;
  }

  if (hours && hours === '12' && period && period === 'PM') {
    h = parseInt(hours, 10) * 3600;
  }

  if (hours && !period) {
    h = parseInt(hours, 10) * 3600;
  }

  if (minutes) {
    m = parseInt(minutes, 10) * 60;
  }

  if (seconds) {
    s = parseInt(seconds, 10);
  }

  return h + m + s;
};

export const isDate = (value) => {
  const isoDateRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
  const isoDateTimeRegex =
    /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d{3}Z|[+-]\d{4})$/;
  return (
    (typeof value === 'object' && value instanceof Date && !Number.isNaN(value)) ||
    (typeof value === 'string' && isoDateRegex.test(value)) ||
    (typeof value === 'string' && isoDateTimeRegex.test(value))
  );
};

export const isTime = (value) =>
  typeof value === 'string' &&
  /^(\d{2}:\d{2}(:\d{2})?)\s?(AM|PM)?$/i.test(value);
